import {
    HttpClient,
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable, catchError, finalize, map, switchMap, tap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpErrorResponseApp } from "../interfaces/error.interface";
import { AuthService } from "../services/auth.service";
import { AppService } from "../services/app.service";
import { DataService } from "../services/data.service";
import { loadingConfig } from "./loading.config";
import { LoadingService } from "../services/loading.service";

@Injectable()
export class HttpConfig implements HttpInterceptor {

    checkURL(url: any) {
        if (url.indexOf("https") == 0) return url
        if (url.indexOf("http") == 0) return url
        else return `${environment.apiUrl}${url}`
    }

    requestURL: string = ""
    constructor(
        private _auth: AuthService,
        private _app: AppService,
        private ds: DataService,
        private loadingService: LoadingService
    ) {

    }

    appendURL: string = '';

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loadingService.show();
        this.appendURL = /http|https/.test(req.url) ? req.url : `${environment.apiUrl}${req.url}`;
        req = this.AddTokenHeader(req, this._auth.access_token);
        return next.handle(req).pipe(
            // tap(
            //     (event: HttpEvent<any>) => {
            //         if (event instanceof HttpResponse) {
            //             this.loadingService.hide();
            //         }
            //     },
            //     (error: HttpErrorResponse) => {
            //         this.loadingService.hide();
            //     }
            // ),
            finalize(() => {
                this.loadingService.hide();
            }),
            catchError((err) => {
                if (err.status === 200) {
                    this._app.License = true
                }
                if (err.status === 401) {
                    return this.headleRefreshToken(req, next);
                }
                if (err.status === 909) {
                    this._app.License = false
                    // return this.headleRefreshToken(req, next);
                }
                return throwError(err);
            })
        );
    }

    AddTokenHeader(req: HttpRequest<any>, token: any, status: boolean = false) {
        if (status) {
            return req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + token),
                setHeaders: {
                    'organization': this.ds.ogId || '',
                    'branchid': this.ds.branchId || '',
                    'menuid': this.ds.menuId || '',
                    'license': this.ds.license || '',
                    'realmid': this.ds.realmid || '',
                    'Keyapi': '4e2e07a9-4175-408c-8f01-7bd1e1ee1049',
                    'Keyuser': 'AVESTA00001',
                }
            });
        } else {
            return req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + token),
                url: this.appendURL,
                setHeaders: {
                    'organization': this.ds.ogId || '',
                    'branchid': this.ds.branchId || '',
                    'menuid': this.ds.menuId || '',
                    'license': this.ds.license || '',
                    'realmid': this.ds.realmid || '',
                    'Keyapi': '4e2e07a9-4175-408c-8f01-7bd1e1ee1049',
                    'Keyuser': 'AVESTA00001'
                }
            });
        }
    }

    headleRefreshToken(req: HttpRequest<any>, next: HttpHandler) {
        return this._auth.generateRefreshToken().pipe(
            switchMap((data: any) => {
                this._auth.setToken(data);
                return next.handle(this.AddTokenHeader(req, data, true));

            }),
            catchError((err: any) => {

                // ถ้า Refresh Token ไม่ได้จะให้เด้งไปที่หน้าไหน
                // window.location.reload()
                // window.location.href = "https://auth.legitid.org/sign-in?redirectTo=http:%2F%2Flocalhost:4200"
                // window.location.href = "http://localhost:4200"
                return throwError(err);
            })
        );
    }
}
